/**
 * @flow
 * @relayHash e4d918a341a8a81cb3811823a7f81e26
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ChangePasswordInput = {
  oldPassword: string,
  password: string,
  clientMutationId?: ?string,
};
export type PasswordMutationVariables = {|
  input: ChangePasswordInput
|};
export type PasswordMutationResponse = {|
  +ChangePassword: ?{|
    +error: ?string,
    +clientMutationId: ?string,
  |}
|};
export type PasswordMutation = {|
  variables: PasswordMutationVariables,
  response: PasswordMutationResponse,
|};
*/


/*
mutation PasswordMutation(
  $input: ChangePasswordInput!
) {
  ChangePassword(input: $input) {
    error
    clientMutationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ChangePasswordInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "ChangePassword",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ChangePasswordInput!"
      }
    ],
    "concreteType": "ChangePasswordPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "PasswordMutation",
  "id": null,
  "text": "mutation PasswordMutation(\n  $input: ChangePasswordInput!\n) {\n  ChangePassword(input: $input) {\n    error\n    clientMutationId\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "PasswordMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "PasswordMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd06bd61b9ae65ce23340fed841b15367';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/PasswordMutation.graphql.js